import classNames from "classnames";
import ScrollShadowWrapper from "components/shared/ScrollShadowWrapper";
import StyledButton from "components/shared/StyledButton";
import UserAvatar from "components/shared/UserAvatar";
import type { AgreementValidatorExtended } from "containers/ContractValidationEdit/utils";
import { Body, PanelTitle } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";

import styles from "../style.module.scss";

interface IVerifyValidators {
    /**
     * Agreement validators data
     */
    validators: AgreementValidatorExtended[];
    /**
     * Go to next step
     */
    handleNextStep: () => void;
    /**
     * Handle close modal
     */
    onClose: () => void;
    /**
     * When this is the last step in the modal (e.g. Docoon has no email-verification step),
     * the primary button becomes "Send" and calls onConfirm instead of handleNextStep.
     */
    isLastStep?: boolean;
    onConfirm?: () => void;
    isConfirming?: boolean;
}

const VerifyValidators = ({
    validators,
    handleNextStep,
    onClose,
    isLastStep,
    onConfirm,
    isConfirming,
}: IVerifyValidators) => {
    const [t] = useTranslation();

    return (
        <div className={styles["agreement-send-for-validation-step"]}>
            <div className={styles["step-wrapper"]}>
                <div className={styles["step-content-top"]}>
                    <div className={styles["step-head"]}>
                        <PanelTitle>{t("Agreements.ValidationWorkflow")}</PanelTitle>
                        <Body color="grey">{t("Agreements.ApproversInfos")}</Body>
                    </div>
                    <div className={styles["step-body-verify-data"]} style={{ gap: "1.5rem" }}>
                        <ScrollShadowWrapper style={{ maxHeight: "14rem" }}>
                            <div className={styles["validators-wrapper"]}>
                                {validators.map((validator, i) => (
                                    <div key={`validator-${validator.id}`} className={styles["validator"]}>
                                        <UserAvatar
                                            name={validator.firstname}
                                            surname={validator.lastname}
                                            size="x-small"
                                        />
                                        <Body>{validator.fullName}</Body>
                                        <Body>-</Body>
                                        <Body color="grey">{validator.email}</Body>
                                    </div>
                                ))}
                            </div>
                        </ScrollShadowWrapper>
                    </div>
                </div>
                <div
                    className={classNames({
                        [styles["step-actions"]]: true,
                        [styles["double-action"]]: validators.length,
                    })}
                >
                    <StyledButton buttonType="secondary" onClick={onClose}>
                        {t("Agreements.Cancel")}
                    </StyledButton>
                    {isLastStep && onConfirm ? (
                        <StyledButton buttonType="primary" onClick={onConfirm} loading={isConfirming}>
                            {t("Agreements.SendForValidation")}
                        </StyledButton>
                    ) : (
                        <StyledButton buttonType="primary" onClick={handleNextStep}>
                            {t("Agreements.Continue")}
                        </StyledButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyValidators;
